// import { getDateFrom } from '../functions/format_date'
// import Moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      isShowFilter: true,
      isDataPageLoading: true,
      createInvoices: {
        show: false,
        title: 'Create Invoices'
      },
      editInvoices: {
        show: false,
        title: 'Edit Invoices',
        submitButtonText: 'Edit',
        form: null
      },
      createModal: {
        show: false,
        title: 'Create client'
      },
      editModal: {
        show: false,
        title: 'Edit client',
        data: null
      },
      table: {
        fields: [
          {
            key: 'company_name',
            label: 'Company name'
          },
          {
            key: 'first_name',
            label: 'First name',
            sortable: true
          },
          {
            key: 'last_name',
            label: 'Last name',
            sortable: true
          },
          {
            key: 'email',
            label: 'Email'
          },
          {
            key: 'phone',
            label: 'Phone'
          },
          {
            key: 'projects',
            label: 'Project',
            formatter: value => {
              return value ? value.map(project => project.name).join(', ') : ''
            }
          },
          {
            key: 'country.name',
            label: 'Country'
          },
          {
            key: 'city',
            label: 'City'
          },
          {
            key: 'address',
            label: 'Address'
          },
          {
            key: 'zip_code',
            label: 'Zip code'
          },
          {
            key: 'actions',
            label: 'Actions'
          }
        ],
        params: {
          filters: null,
          sorting: null,
          currentPage: '?page=1'
        }
      },
      filters: {
        'company_name': {
          type: 'input',
          name: 'company_name',
          label: 'Company name',
          placeholder: 'Company name',
          value: null
        },
        'first_name': {
          type: 'input',
          name: 'first_name',
          label: 'First name',
          placeholder: 'First name',
          value: null
        },
        'last_name': {
          type: 'input',
          name: 'last_name',
          label: 'Last name',
          placeholder: 'Last name',
          value: null
        },
        'email': {
          type: 'input',
          name: 'email',
          label: 'Email',
          placeholder: 'Email',
          value: null
        }
      },
      tableRowModal: {
        fields: [
          {
            key: 'own_bank_details.summary',
            label: 'Own Bank Details'
          },
          {
            key: 'project.name',
            label: 'Project Name'
          },
          {
            key: 'client_bank_details.summary',
            label: 'Client Bank Details'
          },
          {
            key: 'invoice_status.display_name',
            label: 'Invoice Status'
          },
          {
            key: 'invoice_template_type.name',
            label: 'Invoice Template Type'
          },
          {
            key: 'comment',
            label: 'Comment'
          },
          {
            key: 'comment_national',
            label: 'Comment national'
          },
          {
            key: 'issue_date',
            label: 'Issue Date'
          },
          {
            key: 'due_date',
            label: 'Due Date'
          },
          {
            key: 'invoice_type.type',
            label: 'Invoice Type'
          },
          {
            key: 'client_bank_details',
            type: 'slot',
            label: 'Client name',
            slotName: 'client_name'
          },
          {
            key: 'total_amount',
            label: 'Total Amount'
          },
          {
            key: 'periods',
            type: 'slot',
            label: 'Periods',
            slotName: 'periods'
          },
          {
            key: 'items',
            type: 'slot',
            label: 'Items',
            slotName: 'items'
          },
          {
            key: 'specialisations',
            type: 'slot',
            label: 'Specialisations',
            slotName: 'specialisations'
          }
        ]
      }
    }
  },
  created () {
    this.fetchAllData()
  },
  computed: {
    ...mapGetters({
      getCountries: 'countries/getCountries'
    })
  },
  methods: {
    toggleShowFilter () {
      this.isShowFilter = !this.isShowFilter
    },
    showCreateModal () {
      this.createModal.show = true
    },
    hideCreateModal () {
      this.createModal.show = false
    },
    showEditModal (data) {
      this.editModal.show = true
      this.editModal.data = data
    },
    hideEditModal () {
      this.editModal.show = false
      this.editModal.data = null
    },
    setParamsSort (sortDesc, sortBy) {
      if (sortBy) {
        const sortDirection = sortDesc ? 'desc' : 'asc'
        this.table.params.sorting = `&sort[${sortBy}]=${sortDirection}`
      }
    },
    setParamsCurrentPage (currentPage = 1) {
      this.table.params.currentPage = `?page=${currentPage}`
    },
    fetchCountries () {
      if (this.getCountries.length) return

      this.$api.country.getCountries()
    },
    prepareDataForEditAndCreateRequest (fields) {
      let data = {}

      for (let key in fields) {
        const field = fields[key]
        const name = field['name']
        const value = field['value']
        if (Object.prototype.toString.call(value) === '[object Array]' && value) {
          for (let valueItemKey in value) {
            const valueItemValue = value[valueItemKey]
            data[name] = data[name] ?? []
            data[name][valueItemKey] = (typeof valueItemValue === 'object' && valueItemValue && field['valueField']) ? valueItemValue[field['valueField']] : valueItemValue
          }
        } else {
          data[name] = (typeof value === 'object' && value && field['valueField']) ? value[field['valueField']] : value
        }
      }

      return data
    }
  }
}
